import PropTypes from 'prop-types'
import React from 'react'
import { toRoman } from 'helpers'

import RewardReserve from 'components/RewardReserve/RewardReserve.jsx'

import styles from './Reward.scss'

import { REWARD_COUNT } from './constants.jsx'

export class Reward extends React.Component {
    static propTypes = {
        reward: PropTypes.shape({
            rewardLevel: PropTypes.number,
            reserves: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string,
                count: PropTypes.number,
            })),
        }).isRequired,
    }

    reservesCounter(reserves) {
        let total = 0
        reserves.forEach(reserve => total += reserve.count)
        return total
    }

    render() {
        const { reward } = this.props
        const count = this.reservesCounter(reward.reserves)
        const level = toRoman(reward.rewardLevel)

        const reserves = reward.reserves.map(reserve => (
            <div key={reserve.type} className={styles.reserveItem}>
                <RewardReserve
                    type={reserve.type}
                    count={reserve.count}
                    level={reward.rewardLevel}
                />
            </div>
        ))

        return (
            <div className={styles.base}>
                <div className={styles.description}>
                    <span className={styles.reservesCount}>
                        {REWARD_COUNT(
                            count,
                            <span className={styles.reservesLevel}>{level}</span>
                        )}
                    </span>
                </div>
                <div className={styles.reservesList}>
                    {reserves}
                </div>
            </div>
        )
    }
}

export default Reward



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/Reward/Reward.jsx